var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3337 13H5.66703L5.2997 11.3467C4.86253 11.1757 4.45369 10.9397 4.08703 10.6467L2.47103 11.1553L1.1377 8.846L2.3857 7.70067C2.31585 7.23661 2.31585 6.76472 2.3857 6.30067L1.1377 5.15467L2.47103 2.84533L4.08703 3.354C4.45386 3.06065 4.86293 2.82442 5.30036 2.65333L5.66703 1H8.3337L8.70103 2.65333C9.13819 2.82428 9.54702 3.06027 9.9137 3.35333L11.5297 2.84467L12.863 5.154L11.615 6.29933C11.6849 6.76338 11.6849 7.23528 11.615 7.69933L12.863 8.84467L11.5297 11.154L9.9137 10.6453C9.54712 10.9389 9.13828 11.1753 8.70103 11.3467L8.3337 13Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9C8.10457 9 9 8.10457 9 7C9 5.89543 8.10457 5 7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9Z",
    stroke: "white",
    strokeWidth: 1.66667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsOutlined);
export default __webpack_public_path__ + "static/media/settings-outlined.747be33daccca52f27bad0f241ba4692.svg";
export { ForwardRef as ReactComponent };